import kitTemplate from './moving-center-diy-kit.html';
import truckTemplate from './moving-center-diy-truck.html';
import laborTemplate from './moving-center-diy-labor.html';

import { STATE_NAME as MOVING_CENTER_STATE } from '../moving-center.config';

export const STATE_NAME = `${MOVING_CENTER_STATE}.diy`;
const TITLE_BAR = {
  title: 'Book Your Move',
  icon: 'movingtruck',
};

const createChildStateName = name => `${STATE_NAME}.${name}`;
const createStateConfig = (template, title, page, config = {}) => ({
  ...config,
  views: {
    '@': {
      template,
    },
  },
  scrollTop: true,
  titleBar: TITLE_BAR,
  title,
  analytics: {
    page: `MC DIY ${page}`,
  },
  data: {
    permissions:
      'signedIn && hasMovingCenterData && !isPremiumMovingCenterKind',
  },
});

const movingCenterDiyConfig = createStateConfig(
  kitTemplate,
  TITLE_BAR.title,
  'Landing',
  {
    url: '/diy',
  }
);

const rentTruckConfig = createStateConfig(
  truckTemplate,
  'Just Truck',
  'Rent Truck',
  {
    url: '/truck',
  }
);

const hireLaborConfig = createStateConfig(
  laborTemplate,
  'Just Labor',
  'Hire Labor',
  {
    url: '/labor',
  }
);

export function MovingCenterDiyConfig($stateProvider) {
  'ngInject';
  $stateProvider
    .state(STATE_NAME, movingCenterDiyConfig)
    .state(createChildStateName('truck'), rentTruckConfig)
    .state(createChildStateName('labor'), hireLaborConfig);
}
